module.exports = __webpack_public_path__ + "img/im.196dc124.svg";